import { UNKNOWN_NOTIFICATION_ROUTER_ERROR } from 'anchor-scout-common/types';
import { incorrectNotificationPayload, unrecognizedNotification } from './notificationRouter';
function isNonEmptyString(value) {
    return typeof value === 'string' && value.length > 0;
}
function classifyPayload(payload) {
    if (payload === '') return 'emptyString';
    if (typeof payload !== 'object' || payload == null) return 'notAnObject';
    if (!('type' in payload) || !('notificationType' in payload)) return 'missingNotificationType';
    const { type, notificationType } = payload;
    return isNonEmptyString(type) && isNonEmptyString(notificationType) ? 'typedButUnrouted' : 'missingNotificationType';
}
function classifyRouterError(routerError) {
    if (routerError === unrecognizedNotification) return 'unrecognizedNotification';
    if (routerError === incorrectNotificationPayload) return 'incorrectPayload';
    return UNKNOWN_NOTIFICATION_ROUTER_ERROR;
}
function toWholeCount(value) {
    return value == null || !Number.isFinite(value) || value < 0 ? null : Math.round(value);
}
export function buildNotificationLoadFailureLog(param) {
    let { routerError, payload, pageLoadStatus, resourceTiming } = param;
    return {
        type: 'notificationLoadFailure',
        routerError: classifyRouterError(routerError),
        payloadKind: classifyPayload(payload),
        visibilityState: pageLoadStatus.visibilityState,
        online: pageLoadStatus.online,
        msSincePageLoad: toWholeCount(pageLoadStatus.msSincePageLoad),
        hadResourceTimingEntry: resourceTiming != null,
        durationMs: toWholeCount(resourceTiming === null || resourceTiming === void 0 ? void 0 : resourceTiming.durationMs),
        responseEndMs: toWholeCount(resourceTiming === null || resourceTiming === void 0 ? void 0 : resourceTiming.responseEndMs)
    };
}
export function readNotificationLoadFailureLog(param) {
    let { browser, notificationId, routerError, payload } = param;
    try {
        return buildNotificationLoadFailureLog({
            routerError,
            payload,
            pageLoadStatus: browser.readPageLoadStatus(),
            resourceTiming: browser.findResourceTiming(notificationId)
        });
    } catch (unused) {
        // WHY: this diagnostic runs inside the redirect flow it observes; a throw here would be caught
        // by that flow's catch and swallow the Sentry event and error toast the user is owed.
        return null;
    }
}
